/*
  Consent status tracking:
  - fetch initial value, as user may have consented on a previous visit.
  - monitor for consent status changing on this visit, as this occurs when
    the user clicks the buttons presented on the consent pop-up dialog.
 */
import { tcConfigDidomiPurpose, addToDidomiOnReady, didomiIsEnabled } from "./globalConfig";
import { consentStatus } from "../didomi";
import { postQueuedEventsToCollector } from "./dispatchEvent";
let userIsEligibleToTrackStatus = false;
setInitialDidomiUserStatus();
window.addEventListener("didomi:consent.changed", async () => {
    userIsEligibleToTrackStatus = await consentStatus(tcConfigDidomiPurpose());
    if (userIsEligibleToTrackStatus)
        postQueuedEventsToCollector();
});
export function userIsEligibleToTrack() {
    return userIsEligibleToTrackStatus;
}
function setInitialDidomiUserStatus() {
    const { purpose, vendorId } = tcConfigDidomiPurpose();
    // If Didomi isn't even enabled, default to true
    if (!didomiIsEnabled()) {
        userIsEligibleToTrackStatus = true;
        return;
    }
    addToDidomiOnReady((Didomi) => {
        const status = Didomi.getUserConsentStatus(purpose, vendorId);
        // Note that the status will actually be undefined if the user hasn't made a choice yet
        // This gets coerced into a boolean to ensure types match the Typescript code.
        userIsEligibleToTrackStatus = !!status;
    });
}
